import type { FaireProductEntity } from "../../entity_types/product";

export const p_81ap79qy8j: FaireProductEntity = {
  token: "p_81ap79qy8j",
  type: "product",
  name: "Sailboat Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/3ec60e532229d3e0da6f6feb1d364dbd266cb843847df974d85d47e4ff5d6cf6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cb68020eb28b5f61c96029fdc57257bf32c25bc6f16ff379bc32ee9fa0037bfd.jpeg",
    "https://cdn.faire.com/fastly/659216e11ba7c417b2d40fe5e225d063afb49a9d9a7db39cd0bf3b841bc1e047.jpeg",
    "https://cdn.faire.com/fastly/751d0462ce05a0890a79aab60347bb40e11d98b6bda922e4fda102bbb9443af4.jpeg",
    "https://cdn.faire.com/fastly/a14c88521ab61193fb32f43e15d1bc24ea77da02165d98a087e21164c002c030.png",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:37.699Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
